import { createContext } from "react";

const FavoritesContext = createContext();

export default FavoritesContext;
